import React from "react";
import { Spin } from "antd";
import Loader from "../utility/loader";

export const SpinCustom = (props) => (
  <Spin className="isoSpinCustom" indicator={<Loader />} {...props} />
);

export default Spin;
